import {
    faFile,
    faFileExcel,
    faFileImage,
    faFilePdf,
    faFilePowerpoint,
    faFileText,
    faFileWord,
    IconDefinition,
} from "@fortawesome/pro-solid-svg-icons";

/**
 * Takes in an array of classes and combines them use with tailwind (conditional css logic usage)
 * @param classes Array of strings of tailwind classes or regular css class names
 * @returns string of combined class text
 */
export function classNames(...classes): string {
    return classes.filter(Boolean).join(" ");
}

/**
 * Generates a random hex color string from a string
 *
 * This algorithm is deterministic, pseudorandom (I.E. input same string multiple times, get same output)
 * @param str Any basic string (the longer each of your strings in your group the more random)
 * @returns string hex value, including the '#'
 */
export function stringToColor(str: string): string {
    let hash = 0;
    let i = 1;
    if (str) {
        for (i = 0; i < str.length; i += 1) {
            hash = str.charCodeAt(i) + ((hash << 5) - hash);
        }
    }

    let color = "#";

    for (i = 0; i < 3; i += 1) {
        const value = (hash >> (i * 8)) & 0xff;
        color += `00${value.toString(16)}`.slice(-2);
    }
    return color;
}
export function pickTextColorBasedOnBgColor(bgColor: string, lightColor = "#ffffff", darkColor = "#000000") {
    const color = bgColor.charAt(0) === "#" ? bgColor.substring(1, 7) : bgColor;
    const r = parseInt(color.substring(0, 2), 16); // hexToR
    const g = parseInt(color.substring(2, 4), 16); // hexToG
    const b = parseInt(color.substring(4, 6), 16); // hexToB
    return r * 0.299 + g * 0.587 + b * 0.114 > 186 ? darkColor : lightColor;
}

export function fileTypeColorHelper(fileType: string): string {
    switch (fileType) {
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
        case "svg":
            return "orange";
        case "text/plain":
            return "gray";
        case "application/pdf":
        case "pdf":
            return "red";
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
        case "doc":
        case "docx":
            return "blue";
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        case "xls":
        case "xlsx":
        case "csv":
            return "green";
        case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
            return "purple";
        default:
            return "gray";
    }
}

export function fileTypeIconHelper(fileType: string): IconDefinition {
    switch (fileType) {
        case "jpg":
        case "jpeg":
        case "png":
        case "gif":
        case "svg":
            return faFileImage;
        case "text/plain":
            return faFileText;
        case "application/pdf":
        case "pdf":
            return faFilePdf;
        case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
            return faFileWord;
        case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
        case "xls":
        case "xlsx":
        case "csv":
            return faFileExcel;
        case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
            return faFilePowerpoint;
        default:
            return faFile;
    }
}

export function camelToUnderscore(item: string) {
    const result = item.replace(/([A-Z])/g, " $1");
    return result.split(" ").join("_").toLowerCase();
}

export function underscoreToCamel(item: string) {
    return item.toLowerCase().replace(/_./g, (x) => x[1].toUpperCase());
}
